import React, { ComponentPropsWithoutRef } from 'react'
import { WebTarget } from 'styled-components'

import { useStoreState } from '../../store'
import { StyledFlowCard } from './styles'

type Props = ComponentPropsWithoutRef<typeof StyledFlowCard> & {
  as?: WebTarget
}

export const FlowCard: React.FC<Props> = ({ children, ...rest }) => {
  const embedded = useStoreState(state => state.onboarding.embedded)

  return (
    <StyledFlowCard {...rest} $embedded={!!embedded}>
      {children}
    </StyledFlowCard>
  )
}
